import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {Image} from '@freckle/educator-materials/ts/components/img'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {Text} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {Routes} from '@freckle/classroom/ts/common/routers/routes'
import {requestQuoteStyle, premiumStarIcon} from './style.module.scss'

export function GetPremium() {
  const {t} = useSafeTranslation()
  return (
    <Link
      size="md"
      style="normal"
      className={requestQuoteStyle}
      href={Routes.pricing()}
      dataTest="get-freckle-premium-link"
      reactRouter
    >
      <Image
        className={premiumStarIcon}
        src={`${PATHS.imageAssetsUrl}/icons/ic_premium-stars-teal.svg`}
      />
      <Text style="subtitle-2" htmlElement="span">
        {t('NAV_ITEM_GET_FRECKLE_PREMIUM')}
      </Text>
    </Link>
  )
}
